import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

export default mutatorAction('setCategory', function setCategory(
    categoryKey: string,
    subcategoryKey: string,
    currentOptionKey: string
) {
    const store = getStore();
    store.currentCategoryKey = categoryKey;
    store.currentSubCategoryKey = subcategoryKey;
    store.currentOptionKey = currentOptionKey;
});
